import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { SlideHeader } from './SlideHeader'
import { setCourseReportType } from 'store/CustomReports/actions'
import { useEffect } from 'react'
import { setSingleCourse } from 'store/CustomReports/actions'
import { resetMultipleCourses } from 'store/CustomReports/actions'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'
import ReportTypes from './ReportTypes'

function CourseReportType() {
  const { courseReportTypes, selectedCourseReportType, editingReport } =
    useSelector((store) => store.customReports)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!editingReport) {
      dispatch(setSingleCourse(null))
      dispatch(resetMultipleCourses())
    }
  }, [editingReport, dispatch])

  useEffect(() => {
    wait(() => {
      if (selectedCourseReportType !== null) {
        dispatch(setContinueDisabled(false, 2))
      }
    })
  }, [dispatch, selectedCourseReportType])

  const handleClick = (type) => {
    dispatch(setCourseReportType(type))
  }

  return (
    <>
      <SlideHeader header='Select Your Course Report Type' />
      <ReportTypes
        types={courseReportTypes}
        selectedType={selectedCourseReportType}
        fn={handleClick}
      />
    </>
  )
}

export default CourseReportType
